<lib-collapsible-image-list-panel
  [items]="images()"
  [processing]="processing()"
  [labels]="labels"
  [showEmptyState]="images().length < 2"
  [canDeleteItem]="canDeleteImage"
  [canDuplicateItem]="canAlwaysDuplicate"
  (filesSelected)="filesSelected.emit($event)"
  (itemReordered)="imageReordered.emit($event)"
  (itemDeleted)="imageDeleted.emit($event)"
  (itemDuplicated)="imageDuplicated.emit($event)">
  <ng-template #itemMeta let-item>
    @if (showPositions()) {
    <div class="item-meta-fields">
      <label class="item-meta-field">
        <span>X</span>
        <input
          type="number"
          min="0"
          max="20000"
          step="1"
          [value]="item.x"
          (change)="onPositionChanged(item, 'x', $event)" />
      </label>
      <label class="item-meta-field">
        <span>Y</span>
        <input
          type="number"
          min="0"
          max="20000"
          step="1"
          [value]="item.y"
          (change)="onPositionChanged(item, 'y', $event)" />
      </label>
    </div>
    }
  </ng-template>
</lib-collapsible-image-list-panel>
